<template>
  <div>
    <Header />

    <Contents/>

    <Footer />
  </div>
</template>


<script>
import Header from "../../components/private/Header";
import Footer from '../../components/layout/Footer.vue';
import Contents from "./components/producto/Contents.vue"

export default {
    components:{
        Header,
        Contents,
        Footer
    }
}
</script>